const server = 'https://portal.tacna.net/'
//const server = 'http://dev.tacna.net:1212/'
//const server = 'http://10.147.20.150:1213/'
//const server = 'https://dev.tacna.net/'
//const server = 'http://10.147.20.150:4444/'

export const BASE_URL = server
export const URL_EXPORT_CSV = `${server}/internal_api/export_csv`
export const URL_CUSTOM_REPORT = `${server}/report_custom/`
